import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-detail-title-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./detail-title-mrh.component.html",
})
export class DetailTitleMrhComponent {
  @Input() titleKey!: string;
  @Input() reference!: string;
}
